// extracted by mini-css-extract-plugin
module.exports = {"right":"whatsapp_right_2y-8z","body":"whatsapp_body_k7U6K"};